var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChuridar0101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:#fff;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#000;stroke-miterlimit:10;}.cls-1{stroke-width:2px;}.cls-2{stroke-width:1.98px;}.cls-3{stroke-width:0.99px;}.cls-4{stroke-width:1.71px;}.cls-5{stroke-width:1.65px;}.cls-7,.cls-8{fill:none;}.cls-8{stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.66,360.64v11.54c0,1.52,0,3,.07,4.54.06,3,.14,6,.24,8.89.26,7.75.66,15.29,1.16,22.56,0,.76.1,1.5.16,2.25.52,7.47,1.16,14.65,1.87,21.47-5.45.75-14.07.52-19.65.95-5.74.43-15.86-.43-21.52-.33q-.26-5.38-.51-10.6-1-20.07-1.88-37.91c-.1-2.12-.21-4.2-.33-6.26-.1-1.85-.19-3.68-.29-5.5q-.49-8.76-1-17-.33-5.46-.69-10.77c0-.64-.09-1.28-.13-1.92-1.78-26.39,0-49.61-1.54-67.74-3-35.86-6.71-73.18-1.72-124.52,2.12-21.79,5.17-39.72,7.55-51.94l58,4.19q-.15,49.2-.34,98.39c-10,36.14-15.93,80.47-18.71,131.94q-.43,7.92-.62,15.73Q191.74,354.63,191.66,360.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.36,274.73c-1.53,18.13.24,41.35-1.54,67.74-.1,1.49-.19,3-.27,4.51-.57,10.76-.65,22-.67,33.87v17.54c0,3.7-.05,7.47-.11,11.31,0,3.62-.13,7.28-.24,11s-.25,7.62-.44,11.72c-5.67-.1-18.82.76-24.56.33-5.58-.43-11.76-1.9-17.21-2.66q.72-7,1.16-14.39c.22-3.47.38-7,.51-10.6v-1c0-1.33.08-2.67.11-4,0-1,.05-2.07.07-3.12.06-2.58.09-5.19.09-7.81q0-7.38-.1-15-.09-6.42-.32-13-.45-13.83-1.25-28.4c-2.78-51.47-8.73-95.8-18.71-131.94q-.15-49.18-.34-98.39l58-4.19c2.38,12.22,5.43,30.15,7.55,51.94C282.07,201.56,278.4,238.88,275.36,274.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.72,97.56c5.16,5.17,16.91,4.78,16.91,4.78,12.9-.43-.32,2,31.21,2.24,15.69.13,23.54.2,34.57-.78a259.17,259.17,0,0,0,33.8-5.26c.33-1.86-.06-2.7-.48-3.12s-.93-.49-1.05-1,.63-.91.67-1.75-.9-1.14-1-2.25c0-.61.24-.64.48-1.75.2-1,.39-1.85,0-2.25s-1.48.42-3.46.39c-1.66,0-1.78-.69-3-.48-1.64.28-1.9,1.64-3.16,1.56-1.06-.07-1.13-1-2.31-1.17s-1.28.59-2.88,1-1.6-.19-3.27.1c-1.84.32-1.9,1-3.36,1.07s-1.57-.63-3.07-.58-1.53.64-3.07.87-1.93-.35-3.84-.39c-2.14,0-2,.71-4.23.78s-2.65-.72-5-.48c-1.34.13-1.34.41-2.69.48-1.85.11-2.05-.39-3.84-.39-2,0-2.12.63-4.13.59-1.62,0-1.55-.43-3.17-.49-2.13-.08-2.49.6-4.61.59-1.76,0-1.6-.48-3.56-.59-2.3-.13-2.55.52-5.09.49-1.82,0-1.79-.36-3.84-.39-2.26,0-2.26.38-4,.29-2.48-.11-2.75-.93-5-.88-1.78,0-1.66.56-3.37.59-2.39,0-2.69-1-5.09-1-2,0-2.07.73-3.74.49-2.07-.29-2.27-1.45-3.94-1.36-1.52.08-2,1.1-3.36.78-.85-.21-.75-.65-1.73-1-1.49-.5-2,.42-3.55,0-1.17-.32-1.2-1-2.31-1.07s-1.08.4-2,.39c-1.63,0-2-1.49-3.27-1.37a3.09,3.09,0,0,0-2.21,2.34c-.27,1.15.39,1.5.29,3.42a7.3,7.3,0,0,1-.38,2.14c-.44,1.27-.95,1.55-1,2.34A3,3,0,0,0,153.72,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.88,90.54a18.05,18.05,0,0,1,4.61.68c1.68.49,2.29,1,3.84,1.08,1.74.13,1.77-.4,3.36-.3,2.18.14,2.62,1.17,5.09,1.56,1.61.26,1.52-.17,3.17,0,3.78.4,4.66,2.69,7.1,2.25,1.57-.29,1.42-1.27,3.27-1.76s2.66.31,5.57.88a50.06,50.06,0,0,0,8,.29c2.65,0,4,0,5-.1,3.84-.38,4.8-1.2,7-.58a17.52,17.52,0,0,0,3.08.88,12.61,12.61,0,0,0,3.07,0c3.71-.39,3.85-1,6-1.08,2.94-.11,3.18,1.06,6,.78,2.19-.21,2-.88,4.13-1.07,2.89-.25,3.42.93,6.34.59,1.7-.21,1.84-.65,3.56-.69,2,0,2.2.54,3.84.49,2.26-.07,2.34-1.22,5-1.66,2.19-.36,2.39.39,4.61-.09,1.85-.41,1.89-1,3.55-1.17,1.83-.24,2.32.36,4,.19a7.92,7.92,0,0,0,3.65-1.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "158.91 93.1 158.91 94.96 157.85 95.86 157.85 97.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "162.33 93.73 162.33 95.59 161.28 96.49 161.28 97.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "167.1 94.96 167.1 96.82 166.04 97.72 166.04 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "171.62 95.23 171.62 97.09 170.57 97.99 170.57 99.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "176.58 95.86 176.58 97.72 175.52 98.62 175.52 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "180.52 97.09 180.52 98.95 179.46 99.85 179.46 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "184.94 97.37 184.94 99.22 183.88 100.13 183.88 101.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "241.69 97.09 241.69 98.95 242.75 99.85 242.75 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "247.45 96.64 247.45 98.5 248.51 99.4 248.51 100.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "252.7 95.86 252.7 97.72 253.76 98.62 253.76 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "257.75 94.96 257.75 96.82 258.8 97.72 258.8 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "261.5 94.28 261.5 96.13 262.56 97.03 262.56 98.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "265.1 93.4 265.1 95.25 266.16 96.16 266.16 97.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 189.26,
    y1: 97.37,
    x2: 188.1,
    y2: 101.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193.46,
    y1: 97.83,
    x2: 192.31,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197.88,
    y1: 97.83,
    x2: 196.73,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.9,
    y1: 97.83,
    x2: 200.75,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 205.18,
    y1: 98.15,
    x2: 204.99,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 210.02,
    y1: 98.15,
    x2: 209.83,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 214.63,
    y1: 98.15,
    x2: 214.44,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 218.87,
    y1: 98.19,
    x2: 219.71,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 223.74,
    y1: 98.19,
    x2: 224.58,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.44,
    y1: 97.8,
    x2: 229.27,
    y2: 102.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 232.72,
    y1: 97.17,
    x2: 233.55,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.87,
    y1: 97.33,
    x2: 237.71,
    y2: 101.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.47,410.26c1.08-1.6,6.58,1,17.4,1.43,7.93.29,11.22-.87,19.57.44,3.79.6,7.93,1.29,8.33,3s-3.28,4.22-6.92,5.08c-4.27,1-6.33-.64-12.76-1.78-11.06-2-15,1.14-20.76-2.14C231.2,414.55,228.6,411.54,229.47,410.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.36,408.57c.63,1.27-3.39,4.29-7.68,5.88-4.45,1.65-9.51,1.18-19.46.18-8.66-.88-12.51-1.89-15.35-4.37-.62-.54-2.51-2.2-1.94-3.47.68-1.55,4.57-1.66,6.48-1.7,6.23-.12,7.63,1.56,14.17,2.5,4.32.62,8.45.56,16.1.44C270.7,408,273,407.74,273.36,408.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.79,399.84c5.78,1.06,11.25,3.2,17.08,4,1.3.18,4.37.57,5.19,2.22s-.75,3.35-.86,3.48c-3.67,4.31-16.55,1.72-27.79-.54-9-1.81-11.95-3.29-13.4-5.7-1.09-1.8-1.76-4.81,0-6.32C232.12,395.16,235.7,397.25,249.79,399.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.52,394.05c15-.45,18.77-1.91,25.84.08,1.71.49,5.46,1.69,7.89,4.64.76.91,1.9,2.3,1.41,3.56-.84,2.15-5.9,2.54-9.19,2.76a59,59,0,0,1-20.54-2.22c-6.8-2.09-15.71-6.11-15-7.93C230.23,394,232.66,394.25,239.52,394.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.68,396.36h0c-2.5-.3-8-1.27-12.32-5-2.44-2.08-5.49-5.83-4.22-7.21.9-1,3.46-.23,12.87,2,10.37,2.4,15.59,3.6,17.62,3.38,4.79-.52,8.88-2.53,13.08-1.07a7.2,7.2,0,0,1,2.71,1.61,5,5,0,0,1,1.51,4.9c-1,2.54-6.86,4.34-14.27,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.79,390.48c9.57-.67,11.34-1.88,12-3.12,1.11-2-.25-5.13-2.7-6.41-2.68-1.4-5.34.05-11,.89a53,53,0,0,1-18.38-.62c-8.07-1.93-11.5-5.74-14.27-4.28-1.77.93-2,3.38-1.62,5,.3,1.13,1.34,3.41,7.79,6C247.14,391.69,256.17,391.15,265.79,390.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.63,382.37c3.56-.95,6-2.06,7-4.09s.44-4.87-1.52-6-4.61,0-7.89.8c-9.93,2.47-19.41.68-22.05.18-7.93-1.51-10.61-4.39-14.27-2.85-2.57,1.07-4.36,3.79-3.79,6,.19.7,1.06,3,11.68,5.53C256.77,385.72,267.4,383.51,271.63,382.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.55,374.53c4-1.35,6.62-2.9,7.89-5.25.29-.54,1.67-3.08.22-5.35s-4.4-2.72-5.08-2.85c-6.06-1.17-8.43,3.65-17.19,5.17-6.79,1.18-13.39-.31-15.57-.8-6.57-1.48-9.26-3.71-11.57-2.5s-2.8,5.28-1.08,8c2.17,3.45,7.38,4.19,15.68,5.26C258.71,378.14,267.49,375.57,270.55,374.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.69,365.39a25.41,25.41,0,0,0,6.16-3.45c2-1.59,4.25-3.32,3.57-5.33a5.07,5.07,0,0,0-4.33-3c-2.58-.15-3.73,1.9-7.24,3.63-5.64,2.79-13.14,2.66-16.44,2.6-5.14-.08-8.09-1-18.27-1.43a11.11,11.11,0,0,0-5.29.72,3.34,3.34,0,0,0-1.73,4.61c1.53,2.72,7.83,3.56,12.86,4.23C240.43,368.18,257.2,370.27,269.69,365.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.2,403c-1-1.6-6.19,1-16.38,1.42-7.46.3-10.55-.87-18.42.45-3.56.6-7.46,1.28-7.83,3s3.08,4.22,6.51,5.08c4,1,6-.64,12-1.78,10.41-2,14.07,1.13,19.54-2.14C191.58,407.27,194,404.26,193.2,403Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.89,401.29c-.59,1.27,3.19,4.29,7.23,5.88,4.19,1.65,8.95,1.18,18.31.17,8.16-.87,11.78-1.88,14.45-4.36.59-.55,2.37-2.2,1.83-3.48-.64-1.54-4.3-1.65-6.1-1.69-5.86-.12-7.18,1.56-13.33,2.5-4.08.62-8,.55-15.16.44C154.4,400.68,152.28,400.45,151.89,401.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.07,392.55c-5.43,1.07-10.58,3.21-16.07,4-1.22.18-4.11.57-4.89,2.23s.71,3.34.82,3.48c3.45,4.31,15.57,1.72,26.15-.54,8.51-1.82,11.25-3.29,12.62-5.7,1-1.81,1.65-4.81,0-6.33C190.71,387.88,187.34,390,174.07,392.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.74,386.76c-14.09-.44-17.66-1.9-24.32.09a14.74,14.74,0,0,0-7.43,4.64c-.71.91-1.79,2.3-1.32,3.56.79,2.15,5.55,2.54,8.65,2.76a52.08,52.08,0,0,0,19.33-2.23c6.4-2.09,14.79-6.1,14.15-7.93C192.48,386.76,190.2,387,183.74,386.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.94,389.08h0a21.48,21.48,0,0,0,11.6-5c2.3-2.08,5.17-5.84,4-7.22-.85-1-3.25-.22-12.11,2-9.76,2.41-14.68,3.61-16.59,3.39-4.5-.53-8.35-2.53-12.31-1.07a6.59,6.59,0,0,0-2.54,1.6,5.21,5.21,0,0,0-1.43,4.9c.92,2.55,6.46,4.34,13.43,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159,383.2c-9-.67-10.66-1.89-11.29-3.12-1-2,.24-5.13,2.54-6.41,2.52-1.4,5,.05,10.38.89a46.89,46.89,0,0,0,17.3-.63c7.6-1.92,10.83-5.73,13.43-4.27,1.67.93,1.92,3.38,1.53,5-.28,1.13-1.26,3.41-7.33,6C176.57,384.41,168.08,383.87,159,383.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.52,375.09c-3.35-.95-5.68-2.06-6.62-4.1s-.41-4.86,1.43-6,4.35,0,7.43.81c9.35,2.47,18.27.67,20.76.17,7.46-1.5,10-4.39,13.43-2.85,2.42,1.08,4.1,3.8,3.56,6-.17.7-1,3-11,5.53C167.51,378.44,157.51,376.22,153.52,375.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.54,367.25c-3.79-1.36-6.24-2.9-7.43-5.26-.28-.54-1.57-3.08-.21-5.34s4.15-2.72,4.79-2.85c5.7-1.17,7.93,3.64,16.18,5.17,6.38,1.17,12.6-.32,14.65-.81,6.18-1.48,8.71-3.7,10.89-2.49s2.64,5.28,1,8c-2.05,3.45-7,4.19-14.76,5.25C165.68,370.86,157.42,368.28,154.54,367.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.35,358.32a23.6,23.6,0,0,1-5.8-3.22c-1.92-1.48-4-3.1-3.36-5a4.79,4.79,0,0,1,4.07-2.79c2.43-.14,3.51,1.78,6.82,3.4,5.31,2.6,12.36,2.48,15.47,2.42,4.84-.08,7.61-.91,17.2-1.33a10.52,10.52,0,0,1,5,.67,3.1,3.1,0,0,1,1.63,4.3c-1.44,2.54-7.37,3.32-12.11,3.95C182.89,360.93,167.1,362.88,155.35,358.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.37,109.89c2.86,5.77,8.53,32.2-2.85,63.11-5.61,15.23-7.63,26.6-13.59,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.78,106.43c-2.85,5.77-.79,29.88,10.59,60.79,5.61,15.24-.1,28.92,5.86,34.32"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M223,108.46a156.92,156.92,0,0,1-8,70.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M257,115.67c1.16,10.24-9.34,22.86-11.46,38.31-1.68,12.29-5.69,57.34-8.64,65.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.2,104.66c-3.47,21.67,12.35,28.37,14.47,43.82,1.68,12.28-5,47.41,8,65.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.85,104.66a196.06,196.06,0,0,0,10,87.65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuridar0101);
export default __webpack_public_path__ + "static/media/CHURIDAR-01-01.b430b206f4d851834c39cbd107d1f364.svg";
export { ForwardRef as ReactComponent };